// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"875":"227986e4","944":"2cfd6ecc"}[chunkId] + ".chunk.css";
};